import { render, staticRenderFns } from "./sortableItemList.vue?vue&type=template&id=1b7689ed&scoped=true&lang=pug"
import script from "./sortableItemList.vue?vue&type=script&lang=js"
export * from "./sortableItemList.vue?vue&type=script&lang=js"
import style0 from "./sortableItemList.vue?vue&type=style&index=0&id=1b7689ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7689ed",
  null
  
)

export default component.exports